'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controls = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: absolute;\n    bottom: 0;\n    padding: 15px 20px 20px;\n    background: #fff;\n    width: 100%;\n    border-top: 1px solid #ddd;\n    z-index: 2000;\n    box-sizing: border-box;\n'], ['\n    position: absolute;\n    bottom: 0;\n    padding: 15px 20px 20px;\n    background: #fff;\n    width: 100%;\n    border-top: 1px solid #ddd;\n    z-index: 2000;\n    box-sizing: border-box;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    float: right;\n'], ['\n    float: right;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    color: #f5222d;\n    margin-top: 10px;\n    white-space: pre-wrap;\n'], ['\n    color: #f5222d;\n    margin-top: 10px;\n    white-space: pre-wrap;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

var _Button = require('./formComponents/Button');

var _ProgressBar = require('./ProgressBar');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ControlPanel = _styledComponents2.default.div(_templateObject);

var Version = _styledComponents2.default.span(_templateObject2);

var FormError = _styledComponents2.default.div(_templateObject3);

var Controls = exports.Controls = function (_Component) {
    _inherits(Controls, _Component);

    function Controls() {
        _classCallCheck(this, Controls);

        return _possibleConstructorReturn(this, (Controls.__proto__ || Object.getPrototypeOf(Controls)).apply(this, arguments));
    }

    _createClass(Controls, [{
        key: 'renderFormError',
        value: function renderFormError() {
            var formError = this.props.formError;


            return formError && _react2.default.createElement(
                FormError,
                null,
                _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, {
                    id: formError.message,
                    values: {
                        length: formError.length,
                        minLength: formError.minLength
                    } })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                disableBack = _props.disableBack,
                disableForward = _props.disableForward,
                onBack = _props.onBack,
                handleSubmit = _props.handleSubmit,
                onSave = _props.onSave,
                onForward = _props.onForward,
                viewMode = _props.viewMode,
                pagesCount = _props.pagesCount,
                buttons = _props.buttons,
                progress = _props.progress,
                showProgress = _props.showProgress;


            return viewMode && pagesCount <= 1 ? null : _react2.default.createElement(
                ControlPanel,
                null,
                showProgress && _react2.default.createElement(_ProgressBar2.default, { progress: progress }),
                pagesCount > 1 && _react2.default.createElement(
                    _Button.Button.Group,
                    null,
                    buttons.prev.visible && _react2.default.createElement(
                        _Button.Button,
                        { disabled: disableBack, onClick: onBack },
                        _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, { id: buttons.prev.text })
                    ),
                    buttons.next.visible && _react2.default.createElement(
                        _Button.Button,
                        { disabled: disableForward, onClick: viewMode ? onForward : handleSubmit },
                        _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, { id: buttons.next.text })
                    )
                ),
                !viewMode && _react2.default.createElement(
                    _Button.Button.Group,
                    null,
                    onSave && buttons.save.visible && _react2.default.createElement(
                        _Button.Button,
                        { onClick: onSave },
                        _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, { id: buttons.save.text })
                    ),
                    disableForward && buttons.send.visible && _react2.default.createElement(
                        _Button.Button,
                        { onClick: handleSubmit },
                        _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, { id: buttons.send.text })
                    )
                ),
                buttons.lang.visible && _react2.default.createElement(
                    _experiumPlayerHelpersLegacy.LanguageContext.Consumer,
                    null,
                    function (_ref) {
                        var language = _ref.language,
                            setLanguage = _ref.setLanguage;
                        return _react2.default.createElement(
                            _Button.Button.Group,
                            null,
                            _react2.default.createElement(
                                _Button.Button,
                                {
                                    onClick: function onClick() {
                                        return setLanguage(_experiumPlayerHelpersLegacy.RUS);
                                    },
                                    active: language === _experiumPlayerHelpersLegacy.RUS },
                                buttons.lang.text.rus
                            ),
                            _react2.default.createElement(
                                _Button.Button,
                                {
                                    onClick: function onClick() {
                                        return setLanguage(_experiumPlayerHelpersLegacy.ENU);
                                    },
                                    active: language === _experiumPlayerHelpersLegacy.ENU },
                                buttons.lang.text.enu
                            )
                        );
                    }
                ),
                '2.1.51' && _react2.default.createElement(
                    Version,
                    null,
                    'v',
                    '2.1.51'
                ),
                this.renderFormError()
            );
        }
    }]);

    return Controls;
}(_react.Component);

Controls.propTypes = {
    onBack: _propTypes2.default.func,
    onForward: _propTypes2.default.func,
    handleSubmit: _propTypes2.default.func,
    onSave: _propTypes2.default.func,
    disableBack: _propTypes2.default.bool,
    disableForward: _propTypes2.default.bool,
    viewMode: _propTypes2.default.bool,
    pagesCount: _propTypes2.default.number,
    formError: _propTypes2.default.object,
    buttons: _propTypes2.default.object,
    progress: _propTypes2.default.number,
    showProgress: _propTypes2.default.bool
};
Controls.defaultProps = {
    buttons: {}
};